import { createSlice } from "@reduxjs/toolkit";

const initialSuggestions = [];

const suggestionsSlice = createSlice({
    name: "suggestions",
    initialState: initialSuggestions,
    reducers: {
        pushSuggestions(state, action) {
            state.push(action.payload);
        },
        updateSuggestions(state, action) {
            state.push(action.payload);
        },
        resetSuggestions(state, action) {
            return initialSuggestions;
        },
    },
});

export default suggestionsSlice;
